import { media, styled } from '@nx-kit/styling';
import Icon from 'components/atoms/Icon/Icon';

export const Wrapper = styled.div`
  position: relative;
  height: 500px;
  width: 100%;
  overflow: hidden;
  background-color: #c4d15d;
  cursor: pointer;
`;

export const ToolBoxTopStyled = styled.div`
  position: absolute;
  width: calc(100% - 40px);
  height: 30px;
  z-index: ${({ theme }) => theme.global.zIndex.one};
  top: 20px;
  left: 20px;
`;

export const Toast = styled.div`
  display: flex;
  width: 100%;
  min-height: 40px;
  padding: 10px;
  background: ${(props) => props.theme.global.color.white};
  box-shadow: 0 10px 20px -13px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  font-size: 13px;
  line-height: 20px;
  align-items: flex-start;
  ${media('md')} {
    align-items: center;
  }
`;

export const IconInfoStyled = styled(Icon)`
  color: ${({ theme }) => theme.global.color.primary};
  height: 24px;
  min-width: 24px;
  margin-right: 7px;
`;

export const ButtonCloseStyled = styled.button`
  all: unset;
  border: none;
  cursor: pointer;
  margin-left: auto;
  height: 20px;
`;

export const IconCloseStyled = styled(Icon)`
  color: ${({ theme }) => theme.global.color.primary};
`;

export const ToolBoxBottomStyled = styled.div`
  position: absolute;
  width: 46px;
  bottom: 20px;
  right: 20px;
  z-index: ${({ theme }) => theme.global.zIndex.one};
`;

export const ButtonCenterStyled = styled.button`
  background: ${(props) => props.theme.global.color.white};
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 22px;
    height: 22px;
  }
`;

export const ZoomButtonsGroupStyled = styled.div`
  border-radius: 8px;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.12);
  background: ${(props) => props.theme.global.color.white};
  width: 40px;
  margin-top: 10px;
`;

export const ButtonZoomInStyled = styled.button`
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid ${(props) => props.theme.global.color.gray500};

  svg {
    width: 18px;
    height: 18px;
  }
`;

export const ButtonZoomOutStyled = styled.button`
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 18px;
    height: 18px;
  }
`;

export const ImageStyled = styled.image`
  pointer-events: none;
`;

export const RectStyled = styled.rect`
  cursor: default;
`;
